import React from 'react';

import { List } from 'components/List/List';

import { useIsMobile } from 'hooks/useMobile';

import { CircledDottedSchemeDesktop, CircledDottedSchemeProps } from './CircledDottedSchemeDesktop';

import './CircledDottedScheme.scss';

export const CircledDottedScheme = ({ ...props }: CircledDottedSchemeProps) => {
  const isMobile = useIsMobile();

  return isMobile ? (
    <div className={`circled-dotted-scheme-list ${props.containerClass}`}>
      <List items={props.items} />
    </div>
  ) : (
    <CircledDottedSchemeDesktop {...props} />
  );
};
